<template>
  <div class="wg-row">
    <!-- <wg-modal
      v-if="openContractModal"
      :width="windowWidth > 700 ? '500px' : '90%'"
      @closeModal="openContractModal = false"
    >
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "Details", "Dettagli") }}
        </div>
      </div>
      <contract-details
        :contact="contact"
        @save="editContact"
        slot="body"
      ></contract-details>
    </wg-modal> -->
    <div class="wg-row detail-row">
      <img
        :title="'Dimensione stabilimento'"
        class="com-anm22-app-img-fixed-height-m"
        :src="$anm22.icons.getWorldIcon('beachSize')"
      />
      <select
        @change="save"
        class="com-anm22-app-select"
        v-model="otherInformations.beachDimension"
      >
        <option value>
          {{
            $anm22.strLang(
              lang,
              "No dimension",
              "Nessuna dimensione specificata"
            )
          }}
        </option>
        <option
          v-for="(dimension, index) in beachDimensions"
          :key="'dim-' + index"
          :value="dimension"
        >
          {{ dimension }}
        </option>
      </select>
    </div>
    <div class="vertical-height-div" style="height: 15px"></div>
    <div class="wg-row">
      <div class="wg-row detail-row com-anm22-app-text-xxl">
        {{ $anm22.strLang(lang, "Interested to", "Interessato a") }}
      </div>
      <div class="wg-row detail-row">
        <div class="com-anm22-app-text-m wg-col wg-xs-4 wg-sm-2">
          {{ $anm22.strLang(lang, "Beach", "Spiaggia") }}
        </div>
        <div class="wg-col wg-xs-2 wg-sm-2">
          <input
            id="beach"
            @change="save"
            type="checkbox"
            :value="1"
            style="display: none"
            v-model="interestedTo.beach"
          />
          <label class="label-input-radio" for="beach" data-cy=details-interest-beach>{{
            interestedTo.beach ? "✔" : ""
          }}</label>
        </div>
      </div>
      <div class="wg-row detail-row">
        <div class="com-anm22-app-text-m wg-col wg-xs-4 wg-sm-2">
          {{ $anm22.strLang(lang, "Food", "Food") }}
        </div>
        <div class="wg-col wg-xs-2 wg-sm-2">
          <input
            id="food"
            @change="save"
            type="checkbox"
            :value="1"
            style="display: none"
            v-model="interestedTo.food"
          />
          <label class="label-input-radio" for="food">{{
            interestedTo.food ? "✔" : ""
          }}</label>
        </div>
      </div>
      <div class="wg-row detail-row">
        <div class="com-anm22-app-text-m wg-col wg-xs-4 wg-sm-2">
          {{ $anm22.strLang(lang, "Booking", "Booking") }}
        </div>
        <div class="wg-col wg-xs-2 wg-sm-2">
          <input
            id="booking"
            @change="save"
            type="checkbox"
            :value="1"
            style="display: none"
            v-model="interestedTo.booking"
          />
          <label class="label-input-radio" for="booking">{{
            interestedTo.booking ? "✔" : ""
          }}</label>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 15px"></div>
    <div class="wg-row detail-row com-anm22-app-text-xxl">
      <span>{{ $anm22.strLang(lang, "Place", "Sede") }}</span>
      <img
        :title="$anm22.strLang(lang, 'Place', 'Sede')"
        class="com-anm22-app-img-fixed-height-l"
        :src="$anm22.icons.getWorldIcon('gpsPlace')"
      />
    </div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Address", "Indirizzo") }}
          </div>
          <div class="wg-row input-elem" style="aling-items: center">
            <input
              class="com-anm22-app-input-text"
              style="width: 155px"
              type="text"
              @change="save"
              :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
              v-model="otherInformations.addressStreet"
            />
            <input
              class="com-anm22-app-input-text"
              style="width: 40px; margin-left: 5px"
              type="text"
              @change="save"
              placeholder="N."
              v-model="otherInformations.addressNumber"
            />
          </div>
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "City", "Città") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            @change="save"
            :placeholder="$anm22.strLang(lang, 'City', 'Città')"
            v-model="otherInformations.addressCity"
          />
        </div>
      </div>
    </div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "ZIP", "CAP") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            @change="save"
            :placeholder="$anm22.strLang(lang, 'ZIP', 'CAP')"
            v-model="otherInformations.addressZip"
          />
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "State", "Provincia") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            @change="save"
            :placeholder="$anm22.strLang(lang, 'State', 'Provincia')"
            v-model="otherInformations.addressState"
          />
        </div>
      </div>
    </div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Region", "Regione") }}
          </div>
          <select
            @change="save"
            class="input-elem com-anm22-app-select"
            v-model="otherInformations.addressRegion"
          >
            <option value="" selected="">
              {{ $anm22.strLang(lang, "Select", "Seleziona") }}
            </option>
            <option
              v-for="region in regions"
              :key="'region-' + region"
              :value="region"
            >
              {{ region }}
            </option>
          </select>
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Country", "Paese") }}
          </div>
          <select
            @change="save"
            class="input-elem com-anm22-app-select"
            v-model="otherInformations.addressCountry"
          >
            <option value selected disabled hidden>
              {{ $anm22.strLang(lang, "Select", "Seleziona") }}
            </option>
            <option
              v-for="obj in Object.values(
                $anm22.tableClasses.worldCountry().getAll()
              ).sort((a, b) =>
                a[lang] < b[lang] ? -1 : b[lang] > b[lang] ? 1 : 0
              )"
              :key="'country-' + obj.typeClassLiteral"
              :value="obj.typeClassLiteral"
            >
              {{ obj[lang] }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 15px"></div>
    <div class="wg-row detail-row">
      <div class="com-anm22-app-text-xxl">
        {{ $anm22.strLang(lang, "Other jobs", "Altre attività") }}
      </div>
    </div>
    <div class="wg-row detail-row">
      <img
        :title="'Ristorante'"
        class="com-anm22-app-img-fixed-height-l"
        :src="$anm22.icons.getWorldIcon('pickUpRestaurant')"
      />
      <div>
        <input
          id="restaurant"
          @change="save"
          type="checkbox"
          :value="1"
          style="display: none"
          v-model="otherInformations.restaurant"
        />
        <label class="label-input-radio" for="restaurant">{{
          otherInformations.restaurant ? "✔" : ""
        }}</label>
      </div>
    </div>
    <div class="wg-row detail-row">
      <img
        :title="'Hotel'"
        class="com-anm22-app-img-fixed-height-l"
        :src="$anm22.icons.getWorldIcon('hotel')"
      />
      <div>
        <input
          id="hotel"
          @change="save"
          type="checkbox"
          :value="1"
          style="display: none"
          v-model="otherInformations.hotel"
        />
        <label class="label-input-radio" for="hotel">{{
          otherInformations.hotel ? "✔" : ""
        }}</label>
      </div>
    </div>
    <div class="com-anm22-app-text-m">
      {{ $anm22.strLang(lang, "Add job", "Aggiungi attività") }}
    </div>
    <img
      :title="$anm22.strLang(lang, 'Add job', 'Aggiungi attività')"
      class="add"
      @click="addInputJob"
      :src="$anm22.icons.getWorldIcon('add')"
    />
    <div
      class="wg-row"
      style="margin-bottom: 2px"
      v-for="(job, index) in jobs"
      :key="'job' + index"
    >
      <input
        style="margin: 2px"
        class="com-anm22-app-input-text"
        type="text"
        v-model="job.desc"
        @change="save"
      />
      <img
        class="com-anm22-app-img-fixed-height-s"
        :src="$anm22.icons.getWorldIcon('deleteBlack')"
        style="cursor: pointer; margin: 11px"
        @click="deleteJob(index)"
      />
    </div>
    <div class="vertical-height-div" style="height: 15px"></div>
    <div class="wg-row">
      <div class="detail-row com-anm22-app-text-xxl">
        {{ $anm22.strLang(lang, "Customizations", "Customizzazioni") }}
      </div>
      <div>
        <input
          id="custom"
          @change="save"
          type="checkbox"
          :value="1"
          style="display: none"
          v-model="otherInformations.customizations"
        />
        <label
          style="margin-left: 10px"
          class="label-input-radio"
          for="custom"
          >{{ otherInformations.customizations ? "✔" : "" }}</label
        >
      </div>
      <div v-if="otherInformations.customizations" class="wg-row">
        <textarea
          class="com-anm22-app-textarea"
          style="height: 100px; max-width: 300px"
          v-model="otherInformations.customizationDesc"
          @change="save"
        ></textarea>
      </div>
      <div class="vertical-height-div" style="height: 15px"></div>
    </div>
    <div class="wg-row">
      <div class="detail-row com-anm22-app-text-xxl">
        {{ $anm22.strLang(lang, "Beach tabs", "Schede spiaggia") }}
      </div>
    </div>
    <div style="cursor: pointer" @click="addBeachTab = !addBeachTab">
      <div style="display: inline-block" class="com-anm22-app-text-m">
        {{ $anm22.strLang(lang, "Add tab", "Aggiungi scheda") }}
      </div>
      <img
        style="display: inline-block"
        :title="
          $anm22.strLang(lang, 'Add beach tab', 'Aggiungi scheda spiaggia')
        "
        class="add"
        :src="$anm22.icons.getWorldIcon('add')"
      />
    </div>
    <div v-if="addBeachTab" class="wg-row">
      <input
        style="margin: 2px"
        class="com-anm22-app-input-text"
        type="number"
        :placeholder="$anm22.strLang(lang, 'beach ID', 'ID spiaggia')"
        v-model="newBeachTab"
        @change="save"
      />
      <img
        class="com-anm22-app-img-fixed-height-s"
        :src="$anm22.icons.getWorldIcon('deleteBlack')"
        style="cursor: pointer; margin: 11px"
        @click="
          newBeachTab = null;
          addBeachTab = false;
        "
      />
    </div>
    <div class="vertical-height-div" style="height: 10px"></div>
    <div
      class="wg-row detail-row"
      style="margin-bottom: 2px"
      v-for="(tab, index) in beachTabs"
      :key="'tab' + index"
    >
      <a :href="'https://team.spiagge.it/beach/' + tab">
        <img
          style="margin: 0 10px 0 10px"
          :title="'https://team.spiagge.it/beach/' + tab"
          class="com-anm22-app-img-fixed-height-l"
          :src="$anm22.icons.getWorldIcon('yourbeachIcon')"
        />
      </a>
      <img
        class="com-anm22-app-img-fixed-height-m"
        :src="$anm22.icons.getWorldIcon('deleteBin')"
        style="cursor: pointer; margin: 9px"
        @click="deleteBeachTable(index)"
      />
    </div>
    <div class="vertical-height-div" style="height: 15px"></div>
    <!-- <div class="wg-row">
      <input
        v-if="!licenseAlreadyPresent"
        type="button"
        class="small"
        :value="$anm22.strLang(lang, 'Generate contract', 'Genera contratto')"
        @click="openContractModal = true"
      />
    </div>
    <div class="vertical-height-div" style="height: 15px"></div> -->
  </div>
</template>
<script>
import _ from "lodash";
import ContractDetails from "./ContractDetails.vue";
import { mapState } from "vuex";

export default {
  props: {
    contactData: Object,
    contacts: Array,
  },
  data() {
    return {
      contact: { ...this.contactData },
      newBeachTab: null,
      addBeachTab: false,
      openContractModal: false,
      jobs: [],
      beachTabs: [],
      interestedTo: {
        beach: false,
        booking: false,
        food: false,
      },
      otherInformations: {
        beachDimension: "",
      },
      regions: [
          'Abruzzo',
          'Basilicata',
          'Calabria',
          'Campania',
          'Emilia-Romagna',
          'Friuli-Venezia Giulia',
          'Lazio',
          'Liguria',
          'Lombardia',
          'Marche',
          'Molise',
          'Piemonte',
          'Puglia',
          'Sardegna',
          'Sicilia',
          'Toscana',
          'Trentino-Alto Adige',
          'Umbria',
          'Valle d\'Aosta',
          'Veneto'
        ]
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
      offline: (state) => state.offline.isOffline,
    }),
    workContact() {
      if (
        this.contact.type != 2 &&
        this.contact.company &&
        this.contact.company != ""
      ) {
        return this.contacts.find(
          (c) =>
            c.type == 2 &&
            c.workOwner == this.contact.workOwner &&
            c.firstName.toUpperCase() == this.contact.company.toUpperCase()
        );
      }
    },
    licenseAlreadyPresent() {
      let alreadyPresent = false;
      /* Controllo che il contatto non abbia gia una licenza associata */
      if (
        this.contact.otherInformations &&
        this.contact.otherInformations["yb-license"]
      ) {
        alreadyPresent = true;
      }
      /* Se il contatto è di tipo azienda e ha dei referenti,controllo che nei referenti non sia stata gia creata una licenza */
      if (this.contact.type == 2) {
        if (
          this.companyContacts(this.contact) &&
          this.companyContacts(this.contact).length > 0
        ) {
          this.companyContacts(this.contact).forEach((contact) => {
            if (
              contact.otherInformations &&
              contact.otherInformations["yb-license"]
            ) {
              alreadyPresent = true;
            }
          });
        }
      } else {
        /* Se è un contatto persona,controllo che nell'eventuale contatto azienda associato non sia stata gia creata una licenza */
        if (this.workContact) {
          if (
            this.workContact.otherInformations &&
            this.workContact.otherInformations["yb-license"]
          ) {
            alreadyPresent = true;
          }
          if (
            this.companyContacts(this.workContact) &&
            this.companyContacts(this.workContact).length > 0
          ) {
            this.companyContacts(this.workContact).forEach((contact) => {
              if (
                contact.otherInformations &&
                contact.otherInformations["yb-license"]
              ) {
                alreadyPresent = true;
              }
            });
          }
        }
      }
      return alreadyPresent;
    },
    beachDimensions() {
      return ["0-70", "70-300", "300-500", "500-1.000", ">1.000"];
    },
  },
  methods: {
    companyContacts(contact) {
      if (contact.type == 2) {
        return this.contacts.filter(
          (c) =>
            c.company &&
            c.company != "" &&
            c.workOwner == contact.workOwner &&
            c.company.toUpperCase() == contact.firstName.toUpperCase()
        );
      }
    },
    addInputJob() {
      this.jobs.push({ desc: "" });
    },
    deleteJob(index) {
      this.jobs.splice(index, 1);
      this.save();
    },
    deleteBeachTable(index) {
      this.beachTabs.splice(index, 1);
      this.save();
    },
    save() {
      /* Controllo che il contatto abbia altre attività */
      if(this.otherInformations.restaurant || this.otherInformations.hotel || (this.jobs.length > 0 && this.jobs.find(job => job.desc != ""))) {
        this.otherInformations.otherActivities = true;
      } else {
        this.otherInformations.otherActivities = false;
      }
      this.contact.otherInformations = this.otherInformations;
      this.contact.otherInformations.interestedTo = this.interestedTo;
      this.contact.otherInformations.jobs = this.jobs;
      //Controllo che non sia un campo vuoto o nullo e che la scheda non sia gia presente.
      if (
        this.newBeachTab != null &&
        this.newBeachTab != "" &&
        !this.beachTabs.find((tab) => tab == this.newBeachTab)
      ) {
        this.beachTabs.push(this.newBeachTab);
      }
      this.contact.otherInformations.beachTabs = this.beachTabs;
      this.editContact();
    },
    generateContract(objData) {
      this.$http
        .post(
          "contact/generate-contract",
          {
            contactId: this.contact.idContactsContact,
            objData: objData,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response) {
            this.$store
              .dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                objs: [response.data.contact],
              })
              .then(() => {
                if (response.data.error) {
                  this.$anm22.eventBus.$emit("world-headbar-show-message", {
                    text: this.$anm22.strLang(
                      this.lang,
                      "Failed contract generation",
                      "Generazione contratto fallita"
                    ),
                    type: "alarm",
                  });
                  this.$anm22.eventBus.$emit("wg-modal-close");
                } else {
                  //Redirect pagina contratto
                  window.open(response.data.url, "_blank");
                  this.$anm22.eventBus.$emit("wg-modal-close");
                }
              });
          }
        })
        .catch((error) => console.log(error));
    },
    editContact(objData) {
      let additionalData = { emails: [], phones: [] };
      this.$http
        .post(
          "contact/edit",
          {
            contact: this.contact,
            additionalData: additionalData,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$store
            .dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact],
            })
            .then(() => {
              this.newBeachTab = null;
              this.addBeachTab = false;
              /* Aggiorno copia oggetto altre informazioni */
              this.otherInformations = this.contact.otherInformations;
              if (typeof objData == "undefined") {
                this.$anm22.eventBus.$emit("wg-modal-close");
              } else {
                //Genero contratto
                this.generateContract(objData);
              }
            })
            .catch((error) => console.log(error));
        });
    },
  },
  components: {
    ContractDetails,
  },
  created() {
    if (
      !this.contact.otherInformations ||
      this.contact.otherInformations.length == 0
    ) {
      this.otherInformations = {};
    } else {
      this.otherInformations = this.contact.otherInformations;
    }
    //Interessi cliente
    if (this.otherInformations.interestedTo) {
      this.interestedTo = this.otherInformations.interestedTo;
    }
    // Altre attività
    if (this.otherInformations.jobs) {
      this.jobs = this.otherInformations.jobs;
    }
    // Schede spiaggia
    if (this.otherInformations.beachTabs) {
      this.beachTabs = this.otherInformations.beachTabs;
    }
    //Dimensione spiaggia
    if (!this.otherInformations.beachDimension) {
      this.otherInformations.beachDimension = "";
    }
    //Country
    if (!this.otherInformations.addressCountry) {
      this.otherInformations.addressCountry = "it";
    }
  },
};
</script>
 
<style lang="scss" scoped>
.add {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-top: -3px;
  margin-left: 4px;
  cursor: pointer;
}
.input-elem {
  max-width: 200px;
}
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.detail-row {
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 10px;

  & img {
    margin: 0 16px 0 10px;
  }
}
</style>
 